define('commons/coverage-overlay-colorizr',['jquery', 'utils/colorizr-methods', 'utils/colorizr-shaders', 'async!google-maps'], function($, colorFunctions, colorShaders) {

var CoverageOverlayColorizr = function(name, tileSize, opacity, single, baseImgUrls, scaled, options) {
    // Now initialize all properties.
    this.tileSize = tileSize;
    this.imgSize = 256;
    this.opacity = Math.min(1, Math.max(0, opacity));
    this.baseImgUrls = baseImgUrls;
    this.scaled = scaled;
    this.name = name;
    this.single = single;
    this.images = {}
    this.settings = {
            envloss: 0,
            maxOffset: 0,
            maxOffsets: [],
            targets: null,
            colorSteps: null,
            rssis: [],
            lowerRange: 0,
            upperRange: 0,
            maxOverlap: 0,
            minDb: 0,
            projection: null,
            mode: "none"
    };
    $.extend(true,this.settings, options);

    this._renderer = document.createElement("canvas");
    this._renderer.width = this._renderer.height = this.imgSize;
    this._glError = false;
    
    this._renderer

    var gl = this._gl = this._renderer.getContext('webgl', {
        premultipliedAlpha: false
    }) || this._renderer.getContext("experimental-webgl", {
        premultipliedAlpha: false
    });
    if (gl) {
        gl.viewportWidth  = this.imgSize;
        gl.viewportHeight = this.imgSize;
        
        this.fragmentShader = this._selectFragment(this.settings.mode);
    
        this._loadGLProgram();
    
        // Init textures
        this._textures = [];
        for (var i=0; i < this.baseImgUrls.length && i<16; i++) {
            gl.activeTexture(gl.TEXTURE0 + i);
            gl.bindTexture(gl.TEXTURE_2D, this._textures[i] = gl.createTexture());
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, this.imgSize, this.imgSize, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    
            gl.uniform1i(gl.getUniformLocation(this._glProgram, "uTexture" + i), i);
        }
    }
};

CoverageOverlayColorizr.prototype._selectFragment = function(mode) {
    switch(mode) {
        case "none":
            return colorShaders.none();
        case "simple":
            return colorShaders.simple(this.settings.envloss, this.settings.maxOffset);
        case "full":
            return colorShaders.detailled_rssi(this.single, this.settings.maxOffset)
        case "full_margin":
            return colorShaders.detailled_margin(this.settings.envloss, this.settings.maxOffset)
        case "overlap_outdoor":
        case "overlap_indoor":
        case "overlap_underground":
            return colorShaders.operator_overlap(this.settings.envloss, this.settings.maxOffset);
        case "land_cover":
            return colorShaders.land_cover();
        case "density":
            return colorShaders.density(this.settings.colorSteps);
        case "progress":
            return colorShaders.progress(this.settings.maxOffset, this.settings.targets, this.settings.colorSteps);
        case "device_location_simple":
            return colorShaders.device_location_simple(this.baseImgUrls.length);
        case "device_location_detailled":
            return colorShaders.device_location_detailled(this.baseImgUrls.length, this.settings.rssis, this.settings.upperRange, this.settings.lowerRange, this.settings.maxOverlap, this.settings.minDb);
        case "simple_progress":
            return colorShaders.simple_progress();
        case "overlap_multiple":
                return colorShaders.overlap_multiple(this.baseImgUrls.length, this.settings.envloss, this.settings.maxOffsets);
        default:
            throw "Invalid mode value: " + mode + ". Shall be one of : 'status', 'signal', 'rssi'.";
    }
};

CoverageOverlayColorizr.prototype._loadGLProgram = function() {
    var gl = this._gl;

    // Force using this vertex shader.
    // Just copy all attributes to predefined variants and set the vertex positions
    var vertexShaderCode =
        "attribute vec2 aVertexCoords;  " +
        "attribute vec2 aTextureCoords;  " +
        "attribute vec2 aCRSCoords;  " +
        "attribute vec2 aLatLngCoords;  " +
        "varying vec2 vTextureCoords;  " +
        "varying vec2 vCRSCoords;  " +
        "varying vec2 vLatLngCoords;  " +
        "varying vec2 vParams;  " +
        "void main(void) {  " +
        "   gl_Position = vec4(aVertexCoords , 1.0, 1.0);  " +
        "   vTextureCoords = aTextureCoords;  " +
        "   vCRSCoords = aCRSCoords;  " +
        "   vLatLngCoords = aLatLngCoords;  " +
        "   vParams = vec2(30.0, 0.0);  " +
        "}";

    // Force using this bit for the fragment shader. All fragment shaders
    // will use the same predefined variants, and
    var fragmentShaderHeader =
        "precision highp float;\n" +
        "varying vec2 vTextureCoords;\n" +
        "varying vec2 vCRSCoords;\n" +
        "varying vec2 vLatLngCoords;\n";

    for (var i=0; i<this.baseImgUrls.length && i<16; i++) {
        fragmentShaderHeader += "uniform sampler2D uTexture" + i + ";\n";
    }


    var program = this._glProgram = gl.createProgram();
    var vertexShader   = gl.createShader(gl.VERTEX_SHADER);
    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(vertexShader, vertexShaderCode);
    gl.shaderSource(fragmentShader, fragmentShaderHeader + this.fragmentShader);
    gl.compileShader(vertexShader);
    gl.compileShader(fragmentShader);

    // @event shaderError
    // Fired when there was an error creating the shaders.
    if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
        this._glError = gl.getShaderInfoLog(vertexShader);
        console.error(this._glError);
        return null;
    }
    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
        this._glError = gl.getShaderInfoLog(fragmentShader);
        console.error(this._glError);
        return null;
    }

    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    gl.useProgram(program);

    // There will be two vec2 vertex attributes per vertex - aCRSCoords and
    // aTextureCoords
    this._aVertexPosition = gl.getAttribLocation(program, "aVertexCoords");
    this._aTexPosition = gl.getAttribLocation(program, "aTextureCoords");
    this._aCRSPosition = gl.getAttribLocation(program, "aCRSCoords");
    this._aLatLngPosition = gl.getAttribLocation(program, "aLatLngCoords");

    //  console.log('Tex position: ', this._aTexPosition);
    //  console.log('CRS position: ', this._aCRSPosition);

    // Create three data buffer with 8 elements each - the (easting,northing)
    // CRS coords, the (s,t) texture coords and the viewport coords for each
    // of the 4 vertices
    // Data for the texel and viewport coords is totally static, and
    // needs to be declared only once.
    this._CRSBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this._CRSBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(8), gl.STATIC_DRAW);
    if (this._aCRSPosition !== -1) {
        gl.enableVertexAttribArray(this._aCRSPosition);
        gl.vertexAttribPointer(this._aCRSPosition, 2, gl.FLOAT, false, 8, 0);
    }

    this._LatLngBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this._LatLngBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(8), gl.STATIC_DRAW);
    if (this._aLatLngPosition !== -1) {
        gl.enableVertexAttribArray(this._aLatLngPosition);
        gl.vertexAttribPointer(this._aLatLngPosition, 2, gl.FLOAT, false, 8, 0);
    }
    
    this._TexCoordsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this._TexCoordsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
        1.0, 0.0,
        0.0, 0.0,
        1.0, 1.0,
        0.0, 1.0,
    ]), gl.STATIC_DRAW);
    if (this._aTexPosition !== -1) {
        gl.enableVertexAttribArray(this._aTexPosition);
        gl.vertexAttribPointer(this._aTexPosition, 2, gl.FLOAT, false, 8, 0);
    }

    this._VertexCoordsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this._VertexCoordsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
         1,  1,
        -1,  1,
         1, -1,
        -1, -1
    ]), gl.STATIC_DRAW);
    if (this._aVertexPosition !== -1) {
        gl.enableVertexAttribArray(this._aVertexPosition);
        gl.vertexAttribPointer(this._aVertexPosition, 2, gl.FLOAT, false, 8, 0);
    }
}

//This is called once per tile - uses the layer's GL context to
//   render a tile, passing the complex space coordinates to the
//   GPU, and asking to render the vertexes (as triangles) again.
// Every pixel will be opaque, so there is no need to clear the scene.
CoverageOverlayColorizr.prototype._render = function (coord, zoom) {
    var gl = this._gl;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.clearColor(0.5, 0.5, 0.5, 0);
    gl.enable(gl.BLEND);

    var tileBounds = this._tileCoordsToBounds(coord, zoom);
    var west = tileBounds.getSouthWest().lng,
        east = tileBounds.getNorthEast().lng,
        north = tileBounds.getNorthEast().lat,
        south = tileBounds.getSouthWest().lat;

    // Create data array for LatLng buffer
    var latLngData = [
        // Vertex 0
        east, north,

        // Vertex 1
        west, north,

        // Vertex 2
        east, south,

        // Vertex 3
        west, south,
    ];

    // ...upload them to the GPU...
    gl.bindBuffer(gl.ARRAY_BUFFER, this._LatLngBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(latLngData), gl.STATIC_DRAW);

    // ...also create data array for CRS buffer...
    // Kinda inefficient, but doesn't look performance-critical
    var min = this.settings.projection.fromLatLngToPoint(new google.maps.LatLng(south, west)),
        max = this.settings.projection.fromLatLngToPoint(new google.maps.LatLng(north, east));

    var crsData = [
        // Vertex 0
        max.x, max.y,

        // Vertex 1
        min.x, max.y,

        // Vertex 2
        max.x, min.y,

        // Vertex 3
        min.x, min.y,
    ];
    // ...and also upload that to the GPU...
    gl.bindBuffer(gl.ARRAY_BUFFER, this._CRSBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(crsData), gl.STATIC_DRAW);

    // ... and then the magic happens.
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
}


CoverageOverlayColorizr.prototype._tileCoordsToBounds = function (coord, zoom) {
    var bp = this._tileCoordsToNwSe(coord, zoom);
    return new google.maps.LatLngBounds(bp[0], bp[1]);
}

CoverageOverlayColorizr.prototype._tileCoordsToNwSe = function (coord, zoom) {
    var projection = this.settings.projection;
    var scale = this.imgSize * 8;
    if (zoom < 11) {
        // for higher zoom level the image space taken is greater
        scale = this.imgSize * 8 / Math.pow(2, 11-zoom);
    }
    var nwPoint = new google.maps.Point(coord.x * scale, coord.y * scale),
        sePoint = new google.maps.Point(nwPoint.x + scale, nwPoint.y + scale),
        nw = this.settings.projection.fromPointToLatLng(nwPoint),
        se = this.settings.projection.fromPointToLatLng(sePoint);
    return [nw, se];
}

CoverageOverlayColorizr.prototype.updateOpacity = function(opacityValue) {
    this.opacity = Math.min(1, Math.max(0, opacityValue));
}

CoverageOverlayColorizr.prototype.updateZoom = function(zoom) {
    if (zoom <= 11) {
        this.scaled = null;
        this.tileSize = new google.maps.Size(256, 256);
    } else {
        this.scaled = zoom;
        var ratio = Math.pow(2, zoom - 11);
        this.tileSize = new google.maps.Size(256 * ratio, 256* ratio);
    }
}

CoverageOverlayColorizr.prototype.cleanContext = function() {
    if (this._gl) {
        try {
            this._gl.getExtension('WEBGL_lose_context').loseContext();
        } catch(error) {
            // do nothing (for microsoft comaptibility
        }
    };
}

CoverageOverlayColorizr.prototype.releaseTile = function(tile) {
    if (this.settings.mode == 'full' || this.settings.mode == 'full_margin') {
        var img = tile.children[0];
        if (img) {
            this.images[img.imageKey] = null;
        }
    }
};

CoverageOverlayColorizr.prototype.getImage = function(imageKey) {
    return this.images[imageKey];
};

CoverageOverlayColorizr.prototype.getTile = function(coord, zoom, ownerDocument) {
    if ((!this.scaled && zoom <= 11) || this.scaled == zoom) {
        var div = ownerDocument.createElement('div');
        div.className = this.name;
        div.style.display = 'none';
        var opacity = this.opacity;
        var size = this.tileSize.width;
        var img = new Image();
        img.width = this.tileSize.width;
        img.height =  this.tileSize.height;

        var texFetches = [];
        var baseImgUrl = this.baseImgUrls[0];
        var _this = this;
        texFetches.push(new Promise(function (resolve,reject) {
            img.crossOrigin = '';
            img.onload = function () {
                if (img.getAttribute('data-colorized')) {
                    img.style.width = size + "px";
                    img.style.height = size + "px";
                    img.style.opacity = opacity;
                    div.style.display = 'block';
                    return;
                }
                resolve(img);
            }.bind(this);
            img.onerror = function () {
                resolve(img);
            }.bind(this)
            // add timestamp to prevent cache
            img.src = baseImgUrl + "/" + Math.min(zoom, 11) + "/" + coord.x + "/" + coord.y + ".png?version=" + new Date().getTime() ;
        }));

        for (var i=1; i<this.baseImgUrls.length; i++) {
            var baseImgUrl = this.baseImgUrls[i];
            texFetches.push(new Promise(function (resolve,reject) {
                var tile = document.createElement('img');
                tile.crossOrigin = '';
                tile.onload = function () {
                    if (img.getAttribute('data-colorized')) {
                        img.style.width = size + "px";
                        img.style.height = size + "px";
                        img.style.opacity = opacity;
                        div.style.display = 'block';
                        return;
                    }
                    resolve(tile);
                }.bind(this);
                tile.onerror = function () {
                    resolve(tile);
                }.bind(this)
                tile.src = baseImgUrl + "/" + Math.min(zoom, 11) + "/" + coord.x + "/" + coord.y + ".png";
            }));
        }

        Promise.all(texFetches).then(function (textureImages) {
            if (this.settings.mode != "none" && (!this.scaled || zoom == this.scaled)) {
                if (this._gl) {
                    this.colorizeImageGL(img, textureImages, coord, zoom, this.settings.mode);
                } else {
                    this.colorizeImage(img, textureImages, this.settings.mode);
                }

                if (this.settings.mode == 'full' || this.settings.mode == 'full_margin') {
                    var imageKey = zoom + "_" + coord.y + "_" + coord.x;
                    img.imageKey = imageKey;
                    this.images[imageKey] = img;
                }
            }
        }.bind(this));

        if (!div.hasChildNodes()) {
            div.appendChild(img);
        }
        return div;
    }
    return ownerDocument.createElement('div');;
};

CoverageOverlayColorizr.prototype.colorizeImageGL = function (img, textureImages, coord, zoom, mode) {
    img.alt= '';

    var canvas = document.createElement("canvas");
    canvas.width = this.imgSize;
    canvas.height = this.imgSize;

    var ctx = canvas.getContext("2d");
    
    var gl = this._gl;
    // ignore empty images
    var empty = true;
    for(var image in textureImages) {
        empty &=textureImages[image].naturalHeight == 0;
    } 
    if (!empty) {
        for (var i=0; i< this.baseImgUrls.length && i<16; i++) {
            gl.activeTexture(gl.TEXTURE0 + i);
            gl.bindTexture(gl.TEXTURE_2D, this._textures[i]);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImages[i]);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
            gl.generateMipmap(gl.TEXTURE_2D);
        }
    
        this._render(coord, zoom);
        ctx.drawImage(this._renderer, 0, 0);
    }
    img.setAttribute('data-colorized', true);
    img.src = canvas.toDataURL(); 
};

CoverageOverlayColorizr.prototype.colorizeImage = function (img, textureImages, mode) {
    img.alt= '';

    var canvas = document.createElement("canvas");
    canvas.width = this.imgSize;
    canvas.height = this.imgSize;

    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var pix = imgd.data;   

    var pixs = [];
    for (var i = 1; i < textureImages.length; i++) {
        var aCanvas = document.createElement("canvas");
        aCanvas.width = this.imgSize;
        aCanvas.height = this.imgSize;

        var aCtx = aCanvas.getContext("2d");
        aCtx.drawImage(textureImages[i], 0, 0);

        var aImgd = aCtx.getImageData(0, 0, aCanvas.width, aCanvas.height);
        pixs.push(aImgd.data);
    }

    for (var i = 0, n = pix.length; i < n; i += 4) {

        // iterate through the pixels
        var pixel;
        switch(mode) {
            case "simple":
                if (this.single) {
                    pixel = colorFunctions.single_simple({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]}, this.settings.envloss, this.settings.maxOffset);} 
                else {
                    pixel = colorFunctions.global_detailled_rssi({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]}, 0, this.settings.maxOffset);
                }
                break;
            case "full":
                if (this.single) {
                    pixel = colorFunctions.single_detailled_rssi({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]}, this.settings.maxOffset);
                } else {
                    pixel = colorFunctions.global_detailled_rssi({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]}, this.settings.maxOffset);
                }
                break;
            case "full_margin":
                if (this.single) {
                    pixel = colorFunctions.single_detailled_margin({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]}, this.settings.envloss, this.settings.maxOffset);
                } else {
                    pixel = colorFunctions.global_detailled_margin({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]}, this.settings.maxOffset);
                }
                break;
            case "overlap_outdoor":
            case "overlap_indoor":
            case "overlap_underground":
                pixel = colorFunctions.operator_overlap({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]}, this.settings.envloss, this.settings.maxOffset);
                break;
            case "land_cover":
                pixel = colorFunctions.land_cover({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]});
                break;
            case "density":
                pixel = colorFunctions.density({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]}, this.settings.colorSteps);
                break;
            case "progress":
                pixel = colorFunctions.progress({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]}, {r: pixs[0][i], g: pixs[0][i+1], b: pixs[0][i+2], a: pixs[0][i+3]}, this.settings.maxOffset, this.settings.targets, this.settings.colorSteps);
                break;
            case "device_location_simple":var pixels = [];
                pixels.push({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]});
                for (var j in pixs) {
                    pixels.push({r: pixs[j][i], g: pixs[j][i+1], b: pixs[j][i+2], a: pixs[j][i+3]});
                }
                pixel = colorFunctions.device_location_simple(pixels);
                break;
            case "device_location_detailled":
                var pixels = [];
                pixels.push({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]});
                for (var j in pixs) {
                    pixels.push({r: pixs[j][i], g: pixs[j][i+1], b: pixs[j][i+2], a: pixs[j][i+3]});
                }
                pixel = colorFunctions.device_location_detailled(pixels, this.settings.rssis, this.settings.upperRange, this.settings.lowerRange, this.settings.maxOverlap, this.settings.minDb);
                break;
            case "simple_progress":
                pixel = colorFunctions.simple_progress({r: pix[i], g: pix[i+1], b: pix[i+2], a: pix[i+3]});
                break;
            default:
                throw "Invalid mode value: " + mode + ". Shall be one of : 'status', 'signal', 'rssi'.";
        }

        if(!!!pixel || pixel !== Object(pixel) || Object.prototype.toString.call(pixel) === '[object Array]') {
            
            if(i === 0) {
                throw 'The colorize option should return an object with at least one of "r", "g", "b", or "a" properties.';
            }

        } else {

            if(pixel.hasOwnProperty('r') && typeof pixel.r === 'number') {
                pix[i] = pixel.r;
            }
            if(pixel.hasOwnProperty('g')) {
                pix[i+1] = pixel.g;
            }
            if(pixel.hasOwnProperty('b')) {
                pix[i+2] = pixel.b;
            }
            if(pixel.hasOwnProperty('a')) {
                pix[i+3] = pixel.a;
            }
        }
        
    }
    ctx.putImageData(imgd, 0, 0);
    img.setAttribute('data-colorized', true);
    img.src = canvas.toDataURL(); 
};

return CoverageOverlayColorizr;
});

